import { connect } from 'react-redux';
import View from './HealthCareView';
import MobileView from '../../MobileFinancialPlan/MobileHealthcare/MobileHealthcareView';
import { setReactCalibrationWidget } from '../FinancialPlanActions';
import {
  goalId,
  goalViewState as goalViewStateSelector,
} from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import { getGoal } from '../FinancialPlanHelpers';
import * as financialPlanSelector from '../FinancialPlanSelector';
import { OVERVIEW } from '../Explanations/ExplanationsConst';

const mapStateToProps = (state, ownProps) => {
  const data = financialPlanSelector.data(state, ownProps);
  const goal = getGoal(data, goalId(state, ownProps));
  const isGoalHealthCare = goal.GoalType === 'healthCare';

  const selectedSection = goalViewStateSelector(state, ownProps).selectedSection || OVERVIEW;

  if (ownProps.isPrint) {
    return {
      goalId: ownProps.goal.GoalId,
      data,
      chartTitle: ownProps.goal.GoalCharts[0].Title,
      chartData: ownProps.goal.GoalCharts[0].Data,
      calibration: financialPlanSelector.calibration(state, ownProps),
      hasGoal: true,
      selectedSection,
      assumptionsValues: ownProps.goal.GoalAssumptions,
    };
  }

  if (isGoalHealthCare) {
    return {
      goalId: goal.GoalId,
      data,
      chartTitle: goal.GoalCharts[0].Title,
      chartData: goal.GoalCharts[0].Data,
      calibration: financialPlanSelector.calibration(state, ownProps),
      hasGoal: isGoalHealthCare,
      selectedSection,
      assumptionsValues: goal.GoalAssumptions,
    };
  }

  return {
    goalId: '',
    data,
    chartTitle: '',
    chartData: [],
    calibration: {},
    hasGoal: isGoalHealthCare,
    selectedSection,
    assumptionsValues: goal.GoalAssumptions,
  };
};

const mapDispatchToProps = dispatch => ({
  setReactCalibrationWidget: (calibration, clientId) => {
    dispatch(setReactCalibrationWidget(calibration, clientId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
export const MobileHealthcare = connect(mapStateToProps, mapDispatchToProps)(MobileView);
